import React from "react"
import "./Header.scss"

const Header = () => {
  return (
    <>
      <header className="header">
        <div className="header-inner">
          <nav className="header-nav">
            <ul>
              <li>
                <a href={`${__PATH_PREFIX__}/`} data-gtm-click="headerMenu-top">
                  TOP
                </a>
              </li>
              <li>
                <a
                  href="#advent-calendar"
                  data-gtm-click="headerMenu-adventCalender"
                >
                  ADVENT CALENDAR
                </a>
              </li>
              <li>
                <a href="#official-merch" data-gtm-click="headerMenu-merch">
                  MERCH
                </a>
              </li>
              <li>
                <a href="#about-event" data-gtm-click="headerMenu-concert">
                  CONCERT
                </a>
              </li>
              <li>
                <a href="#theme-song" data-gtm-click="headerMenu-themeSong">
                  THEME SONG
                </a>
              </li>
              <li>
                <a href="#charaforio" data-gtm-click="headerMenu-charaforio">
                  CHARAFORIO
                </a>
              </li>
              <li>
                <a href="#talents" data-gtm-click="headerMenu-talents">
                  TALENTS
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </>
  )
}

export default Header
